export interface PhoneNormalizationResult {
	raw: string;
	e164: string;
	display: string;
	isEmpty: boolean;
	isValid: boolean;
}

const E164_PHONE_PATTERN = /^\+[1-9]\d{7,14}$/;

export function normalizePhoneNumber(value: any): PhoneNormalizationResult {
	const raw = String(value || "").trim();
	if (!raw) {
		return {
			raw: "",
			e164: "",
			display: "",
			isEmpty: true,
			isValid: true,
		};
	}

	const digits = raw.replace(/\D/g, "");
	let e164 = "";
	if (raw.startsWith("+")) {
		e164 = `+${digits}`;
	} else if (digits.length === 10) {
		e164 = `+1${digits}`;
	} else if (digits.length === 11 && digits.startsWith("1")) {
		e164 = `+${digits}`;
	}

	if (!E164_PHONE_PATTERN.test(e164)) {
		return {
			raw,
			e164: "",
			display: raw,
			isEmpty: false,
			isValid: false,
		};
	}

	return {
		raw,
		e164,
		display: formatE164PhoneNumberForDisplay(e164),
		isEmpty: false,
		isValid: true,
	};
}

export function formatPhoneNumberForDisplay(value: any): string {
	const raw = String(value || "").trim();
	if (!raw) {
		return "";
	}
	const digits = raw.replace(/\D/g, "");
	const usDigits =
		raw.startsWith("+1") && digits.length === 11
			? digits.slice(1)
			: !raw.startsWith("+") && digits.length === 10
				? digits
				: "";
	if (usDigits) {
		return `(${usDigits.slice(0, 3)}) ${usDigits.slice(
			3,
			6,
		)}-${usDigits.slice(6)}`;
	}
	const normalizedE164 = normalizePhoneNumber(raw).e164;
	return normalizedE164
		? formatE164PhoneNumberForDisplay(normalizedE164)
		: raw;
}

function formatE164PhoneNumberForDisplay(e164: string): string {
	const digits = e164.replace(/\D/g, "");
	if (e164.startsWith("+1") && digits.length === 11) {
		const usDigits = digits.slice(1);
		return `(${usDigits.slice(0, 3)}) ${usDigits.slice(
			3,
			6,
		)}-${usDigits.slice(6)}`;
	}
	return e164;
}
